export const Sprite = ({bgImage}) => {
  return (
    <div className='character_sprite' style={{backgroundImage: `url(${bgImage})`}}></div>
  )
}
